// Statusetikettene slik de står i status-tabellen, nøklet på verdien.
//
// Sidene for statusoppsett og e-postmaler hadde hver sin kopi med gamle
// etiketter («Venter på betaling», «Reserverer») og nøkler med «wc-»-prefiks
// som de lagrede verdiene ikke har — så de viste rå nøkler som «quoting».
// Etikettene følger Utvikling | BMAx s. 7-8.
export const STATUS_LABEL = {
  quoting: "Kvalitetssikres",
  pending: "Klar til betaling",
  processing: "Behandler",
  "awaiting-vendor": "Venter på produsent",
  "awaiting-quote": "Venter på tilbud",
  "sold-closed": "Solgt og avsluttet",
  "vendor-confirmed": "Bekreftet av produsent",
  "vendor-rejected": "Avvist av produsent",
  scheduled: "Klar til levering",
  completed: "Fullført",
  cancelled: "Kansellert",
  refunded: "Refundert",
  // Eldre statuser som fortsatt kan stå på gamle ordre.
  waitingdelivery: "Avventer leveranse",
  delivered: "Levert",
  "on-hold": "På vent",
  failed: "Mislyktes",
  "payment-failed": "Betaling feilet",
  "awaiting-payment": "Avventer betaling",
  "in-delivery": "Under levering",
  "checkout-draft": "Utkast",
  "manual-review": "Manuell gjennomgang",
};

export const STATUS_COLOR = {
  quoting: "warning",
  pending: "warning",
  processing: "info",
  "awaiting-vendor": "info",
  "awaiting-quote": "warning",
  "sold-closed": "success",
  "vendor-confirmed": "info",
  "vendor-rejected": "error",
  scheduled: "info",
  completed: "success",
  cancelled: "error",
  refunded: "error",
  delivered: "success",
  failed: "error",
  "payment-failed": "error",
};

/** Godtar både «quoting» og den gamle formen «wc-quoting». */
export const statusKey = (value) => String(value || "").replace(/^wc-/, "");

export const statusLabel = (value) => STATUS_LABEL[statusKey(value)] || value;
export const statusColor = (value) => STATUS_COLOR[statusKey(value)] || "default";
